import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RedirectService } from '../../navigation/services/redirect.service';
import { ErrorMessageService } from './error-message.service';
import { ErrorService } from './error.service';

@Injectable({ providedIn: 'root' })
export class ErrorResponseHandlerService {
  private readonly errorService = inject(ErrorService);
  private readonly errorMessageService = inject(ErrorMessageService);
  private readonly redirectService = inject(RedirectService);

  handleResponse(
    errorResponse: HttpErrorResponse,
    beforeRedirect?: () => void,
  ): void {
    if (this.redirectService.canRedirect(errorResponse.status)) {
      beforeRedirect?.();
      this.redirectService.performRedirect(errorResponse.status);
    } else {
      const problemDetails =
        this.errorService.asProblemDetails(errorResponse.error) ??
        this.errorService.asProblemDetails(errorResponse);

      if (problemDetails) {
        const errorMessage = this.errorService.getErrorMessage(problemDetails);
        this.errorMessageService.add(
          errorMessage,
          `${problemDetails['traceId']}`,
        );
      }
    }
  }
}
